import * as React from 'react';
import { Checkbox } from 'antd';
import { IWidget } from 'common/schema/widget/Widget';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { CheckboxInput } from 'client/ui/form/input/CheckboxInput';

export interface FormWidgetInputBooleanViewProps {
  widget: IWidget;
}

export function FormWidgetInputBooleanView(
  props: FormWidgetInputBooleanViewProps
) {
  const { widget } = props;
  const justify = widget.input!.extra?.optionJustify;

  // Abbiamo un singolo metadato per i campi di testo
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  return (
    <FormWidgetItem name={name} widget={props.widget}>
      <CheckboxInput
        name={name}
        style={justify ? { textAlign: 'justify' } : {}}
      >
        {widget.input?.extra?.optionText ?? ''}
      </CheckboxInput>
    </FormWidgetItem>
  );
}
